/**
 * Redux Reducer for Moodle E-Learning Courses
 *
 * Manages:
 * - List of user's Moodle courses
 * - Operation status for fetch operation (loading, success, error)
 */

import { fromJS } from 'immutable';
import {
  SET_MOODLE_COURSES_DATA,
  SET_MOODLE_COURSES_LOADING,
  SET_MOODLE_COURSES_ERROR,
  CLEAR_MOODLE_COURSES_ERROR,
} from '../../actions/MoodleCourses';

// Initial state
const initialState = fromJS({
  list: [],
  isLoading: false,
  error: null,
  operations: {
    fetch: {
      status: null,
    },
  },
});

/**
 * Moodle courses reducer
 * Handles actions for fetching and managing course data
 *
 * @param {Object} state - Current Redux state
 * @param {Object} action - Redux action object
 * @returns {Object} Updated Redux state
 */
// eslint-disable-next-line default-param-last
function moodleCoursesReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_MOODLE_COURSES_DATA: {
      // Store courses as Immutable list
      return state.set('list', fromJS(action.payload || []));
    }

    case SET_MOODLE_COURSES_LOADING: {
      return state.set('isLoading', action.payload);
    }

    case SET_MOODLE_COURSES_ERROR: {
      return state.set('error', action.payload);
    }

    case CLEAR_MOODLE_COURSES_ERROR: {
      return state.set('error', null);
    }

    // Handle operation status updates from @uncinc/react-drupal-core
    // These are dispatched by setOperationStatus action
    default:
      return state;
  }
}

export default moodleCoursesReducer;
